import * as React from "react";
import classnames from "classnames";
import { AlertCircle as Icon } from "react-feather";
import { CSSTransition } from "react-transition-group";

interface ErrorOverlayProps {
  background?: "primary" | "secondary" | "neutral" | "light";
  color?: "primary" | "secondary" | "neutral" | "light";
  message?: string;
  show: boolean;
}

const ErrorOverlay: React.FC<ErrorOverlayProps> = props => {
  const background = props.background || "light";
  const color = props.color || "secondary";

  return (
    <CSSTransition
      classNames="fade"
      in={props.show}
      timeout={{
        appear: 300,
        enter: 300,
        exit: 200,
      }}
      unmountOnExit
    >
      <div
        className="o-overlay">
        <div
          className={classnames({
            "o-overlay__background": true,
            "bg-primary": background === "primary",
            "bg-secondary": background === "secondary",
            "bg-neutral": background === "neutral",
            "bg-light": background === "light",
          })}>
        </div>
        <div
          className={classnames({
            "o-overlay__content": true,
            "d-flex flex-column": true,
            "text-primary": color === "primary",
            "text-secondary": color === "secondary",
            "text-neutral": color === "neutral",
            "text-light": color === "light",
          })}>
          <Icon width={36} height={36} />
          <div className="mt-3">
            {props.message ?? "Sorry, something went wrong"}
          </div>
        </div>
      </div>
    </CSSTransition>);
};

export default ErrorOverlay;
